/*
 * TalkTools - "Products Featured in This Course" ADD buttons
 * The Zipify One Click Upsell on-page widget only ticks a product and waits for the
 * main Add to Cart. This script makes ADD put the product straight into the cart.
 * Products are looked up by the title shown on each card, so no variant IDs are hardcoded.
 */
(function () {
  if (window.__ttFeaturedAdd) return;
  window.__ttFeaturedAdd = true;

  var BTN = 'a.ocu-product-add__button';
  var CARD = '.ocu-product-card';
  var cache = {};

  function norm(s) {
    return (s || '').replace(/[®™]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cardTitle(card) {
    var el = card.querySelector('[class*="title"], [class*="name"]');
    var t = el && el.innerText && el.innerText.trim();
    if (!t) {
      var lines = card.innerText.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      t = lines[0];
    }
    return t;
  }

  function json(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function resolveVariant(title) {
    var key = norm(title);
    if (cache[key]) return cache[key];
    cache[key] = json('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=10')
      .then(function (res) {
        var list = (res.resources && res.resources.results && res.resources.results.products) || [];
        if (!list.length) throw new Error('No product found for "' + title + '"');
        var hit = list.filter(function (p) { return norm(p.title) === key; })[0] || list[0];
        return json('/products/' + hit.handle + '.js');
      })
      .then(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0];
        if (!v) throw new Error('"' + title + '" is sold out');
        return v.id;
      });
    cache[key].catch(function () { delete cache[key]; });
    return cache[key];
  }

  function toast(msg, ok) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
      'background:' + (ok ? '#6b5fb0' : '#b3261e') + ';color:#fff;padding:12px 18px;border-radius:8px;' +
      'font:600 14px/1.3 Poppins,Arial,sans-serif;box-shadow:0 4px 16px rgba(0,0,0,.25);max-width:90vw;text-align:center';
    t.innerHTML = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, ok ? 4000 : 6000);
  }

  function refreshCartCount() {
    json('/cart.js').then(function (c) {
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count], .cart-count').forEach(function (el) {
        el.textContent = c.item_count;
      });
      var bubble = document.querySelector('.cart-link__bubble');
      if (bubble && c.item_count > 0) bubble.classList.add('cart-link__bubble--visible');
      document.dispatchEvent(new CustomEvent('tt:cart-updated', { detail: c }));
    }).catch(function () {});
  }

  function setLabel(btn, html, disabled) {
    btn.innerHTML = html;
    btn.style.pointerEvents = disabled ? 'none' : '';
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BTN);
    if (!btn) return;
    var card = btn.closest(CARD);
    if (!card) return;

    // Stop Zipify from only "ticking" the item
    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.getAttribute('data-tt-busy') === '1' || btn.getAttribute('data-tt-added') === '1') return;
    var title = cardTitle(card);
    var original = btn.innerHTML;
    btn.setAttribute('data-tt-busy', '1');
    setLabel(btn, 'Adding…', true);

    resolveVariant(title)
      .then(function (id) {
        return json('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
      })
      .then(function (res) {
        btn.setAttribute('data-tt-added', '1');
        setLabel(btn, 'Added ✓', true);
        // Tell the theme's own cart (dropdown/drawer) to rebuild and open
        var product = (res && res.items && res.items[0]) || res;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product } }));
        refreshCartCount();
      })
      .catch(function (err) {
        console.warn('[TalkTools featured add]', err);
        setLabel(btn, original, false);
        toast('Sorry, we could not add that item. Please try again.', false);
      })
      .then(function () { btn.removeAttribute('data-tt-busy'); });
  }, true);
})();